<template>
  <v-dialog v-model="dialogVisible" max-width="450" persistent>
    <v-card rounded="lg">
      <v-card-item>
        <template #prepend>
          <v-avatar color="primary" size="48">
            <v-icon color="white">mdi-account-lock</v-icon>
          </v-avatar>
        </template>
        <v-card-title class="text-h6">Sign in to continue</v-card-title>
        <v-card-subtitle>{{ actionMessage }}</v-card-subtitle>
      </v-card-item>

      <v-card-text>
        <p class="text-body-2 text-medium-emphasis mb-4">
          Don't worry — our <strong>Free plan</strong> includes everything you need to get started!
        </p>

        <v-list density="compact" class="bg-surface-variant rounded-lg mb-4">
          <v-list-item v-for="feature in freeFeatures" :key="feature" density="compact">
            <template #prepend>
              <v-icon color="success" size="18">mdi-check</v-icon>
            </template>
            <v-list-item-title class="text-body-2">{{ feature }}</v-list-item-title>
          </v-list-item>
        </v-list>

        <div class="d-flex flex-column ga-2">
          <v-btn color="primary" size="large" block rounded="lg" class="text-none" @click="goToLogin">
            <v-icon start>mdi-login</v-icon>
            Sign In / Sign Up
          </v-btn>
        </div>
      </v-card-text>

      <v-card-actions class="px-4 pb-4">
        <v-btn variant="text" class="text-none text-medium-emphasis" @click="dismiss">
          Maybe later
        </v-btn>
        <v-spacer />
        <v-btn variant="text" color="primary" class="text-none" to="/pricing" @click="dismiss">
          View Pricing
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'
import { usePendingAction } from '@/composables/usePendingAction'

const router = useRouter()
const { showLoginPrompt, hideLoginPrompt, pendingAction } = usePendingAction()

const dialogVisible = computed({
  get: () => showLoginPrompt.value,
  set: (value: boolean) => {
    if (!value) {
      hideLoginPrompt()
    }
  }
})

const actionMessage = computed(() => {
  const action = pendingAction.value
  if (!action) return 'Sign in to save your progress'

  switch (action.type) {
    case 'addToRecipeBook':
      return 'Sign in to add this recipe to your collection'
    case 'cloneRecipe':
      return 'Sign in to clone this recipe'
    case 'generateRecipe':
      return 'Sign in to generate AI recipes'
    case 'createPantry':
      return 'Sign in to create a pantry'
    default:
      return action.message || 'Sign in to continue'
  }
})

const freeFeatures = [
  'Unlimited pantries & recipe books',
  'Barcode scanning',
  'Shopping lists',
  'Share with family',
  '3 AI recipes per month'
]

const goToLogin = () => {
  // Store the current path so we can redirect back after login
  const returnPath = window.location.pathname
  hideLoginPrompt()
  router.push(`/login?signInSuccessUrl=${encodeURIComponent(returnPath)}`)
}

const dismiss = () => {
  hideLoginPrompt()
}
</script>
